;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingViewTipsList = Marionette.CompositeView.extend({
		template: JST.TippingViewTipsList,
		childViewContainer: '.js-league-tips-list',
		collectionEvents: {
			'sync': 'precessRequest'
		},
		ui: {
			'show_more': '.js-load-more'
		},
		events: {
			'click @ui.show_more': 'showMore'
		},
		initialize: function(){

			this.showPreloader();
			this.rounds = this.getOption('rounds');
			this.league_id = this.getOption('league_id');
			this.league = this.getOption('league');

			this.model.set({
				id: this.league_id,
				offset: 0,
				limit: 50,
				show_more: false
			});

			this.initListeners();

			var requests = [this.rounds.fetch(), this.league.show().fetch({ data: { id: this.league_id } })];

			$.when.apply(null, requests)
				.then(this.initModel.bind(this))
				.then(this.fetchViewCollection.bind(this));

		},

		initListeners: function(){
			this.on('change:rounds:control', this.setModel);

			return this;
		},

		fetchData: function(){

			return $.when.call(requests);
		},
		childViewOptions: function(model){

			return {
				matches: this.model.get('matches')
			}
		},
		initModel: function(){
			var rd = this.rounds.getLastGameRound('id');
			rd.set('selected', true);
			this.model.set({
				round: rd.get('id'),
				matches: rd.get('matches')
			});

			this.trigger('rounds:fetched', this.rounds);
			this.trigger('leagues:view:menu', this.league, this.rounds);

			return this;
		},

		setModel: function(options){

			this.showPreloader();
			this.model.set(_.extend(options, {offset: 0}));
			this.fetchViewCollection();
		},

		fetchViewCollection: function() {
			var data = _.pick(this.model.toJSON(), 'id', 'round', 'offset', 'limit');
			return this.collection.leagueTips()
				.fetch({
					silent:true,
					data: data
				});
		},

		precessRequest: function(){
			this.model.set({
				show_more: this.collection.size() < this.league.get('num_teams')
			});

			this.render()
				.hidePreloader();
		},

		showMore: function(){
			const { offset, limit } = this.model.attributes;
			this.model.set({
				offset: offset + limit
			});

			var data = _.pick(this.model.toJSON(), 'id', 'round', 'offset', 'limit');
			return this.collection.leagueTips()
				.fetch({
					silent:true,
					remove:false,
					data: data
				});
		}
	});

}(window, APP, Backbone, Marionette, $, _));